module.exports = __webpack_public_path__ + "ba989fbe0435c33c59a6f59c0594a3be.png";